<app-toolbar [title]="title"></app-toolbar>

<div class="container">
  <mat-card class="mat-elevation-z10">
    <div style="vertical-align: middle">
      <span class="material-icons && back-nav" routerLink="/startup">navigate_before</span>
    <h1>Accedi</h1>
    </div>
    <mat-card-content fxLayout="column">

      <ng-container *ngIf="errorMessage">
        <div style="padding-bottom: 40px">
          <div class="error">
            {{errorMessage}}
          </div>
        </div>
      </ng-container>

      <form class="form" [formGroup]="loginForm" (ngSubmit)="onSubmit(loginForm.value)">

      <mat-form-field appearance="outline">
        <mat-label>Inserisci la tua email</mat-label>
        <input class="text" matInput placeholder="username@domain.com" formControlName="email" (focusin)="notFocused=false" (focusout)="notFocused=true">
        <ng-container *ngIf="loginForm.get('email').hasError('email') && notFocused">
          <div style="padding-top:15px">
            <span class="error">
             Inserisci un email valida
            </span>
          </div>
        </ng-container>
      </mat-form-field>


      <mat-form-field appearance="outline" style="padding-bottom: 10px">
        <mat-label>Inserisci la tua password</mat-label>
        <input matInput type="password" formControlName="password">
      </mat-form-field>

      <!--<p style="padding-bottom: 20px; cursor: pointer; font-weight: bold; color: #00bfa5"
         routerLink="/recover-password">Non ricordi la tua password?</p>-->
        <p style="padding-bottom: 20px; cursor: pointer; font-weight: bold; color: #00bfa5"
           routerLink="/change-password">Non ricordi come accedere?</p>


        <ng-container *ngIf="submitted">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-container>

        <ng-container *ngIf="!show">
          <button mat-raised-button type="submit" color="primary"
                  [disabled]="!loginForm.valid">Entra</button>
        </ng-container>

      </form>

    </mat-card-content>
  </mat-card>
</div>
